import BaseApiRequest from "./BaseApiRequest";
import { SUBMIT_VERIFY } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class SubmitVerify extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    // idToken: "",
    instntTxnId: "",
  };

  constructor(data) {
    super();
    // this.body.idToken = data.token;
    this.body.instntTxnId = data.instnttxnid;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(SUBMIT_VERIFY);

  getBody = () => this.body;
}
